/**
 * Recipe detail provider.
 *
 * Exposes recipe data, derived domain constraints (archived gating), and thin mutation wrappers.
 */
import { useMemo } from "react";
import { useZero } from "@corpuscomplete/zero-data-transformer/react";
import type { PromiseWithServerResult } from "@rocicorp/zero";
import { mutators } from "@corpuscomplete/core/zero";

export namespace RecipeUI {
  export type Mutations = {
    archive: (recipeId: string, currentVersion: number) => PromiseWithServerResult;
  };

  export function useMutations(): Mutations {
    const z = useZero();

    return useMemo(
      () => ({
        archive: (recipeId, currentVersion) =>
          z.mutate(mutators.recipe.archive({ id: recipeId, currentVersion })),
      }),
      [z],
    );
  }
}
